import { render, staticRenderFns } from "./IncomingDocumentList.vue?vue&type=template&id=3964ffea&"
import script from "./IncomingDocumentList.vue?vue&type=script&lang=js&"
export * from "./IncomingDocumentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports